import { extractClosestEdge } from '@atlaskit/pragmatic-drag-and-drop-hitbox/closest-edge';
import { getReorderDestinationIndex } from '@atlaskit/pragmatic-drag-and-drop-hitbox/util/get-reorder-destination-index';

export default function moveCard({ cards, source, location }) {
  if (!location.current.dropTargets.length) return;

  const sourceId = source.data.id;
  const INITIAL_POS = 16384;

  const destinationListId = location.current.dropTargets.find((target) => target.data.type === 'list')?.data.id;
  const sourceCard = cards.find((c) => c.id === sourceId);
  const destinationCards = cards.filter((c) => c.listId === destinationListId);
  const destinationCard = location.current.dropTargets.find((target) => target.data.type === 'card')?.data;

  let destinationIndex;

  if (destinationCard) {
    const edge = extractClosestEdge(destinationCard);

    let startIndex = destinationCards.findIndex((c) => c.id === sourceId);
    if (startIndex === -1) startIndex = destinationCards.length;

    const indexOfTarget = destinationCards.findIndex((card) => card.id === destinationCard.id);

    destinationIndex = getReorderDestinationIndex({
      startIndex,
      indexOfTarget,
      closestEdgeOfTarget: edge,
      axis: 'vertical',
    });
  } else {
    destinationIndex = destinationCards.length;
  }

  const filteredDestinationCards = destinationCards.filter((c) => c.id !== sourceId);
  const destinationCardIds = filteredDestinationCards.map((c) => c.id);

  const insertAfterId = destinationIndex > 0 ? destinationCardIds[destinationIndex - 1] : null;
  const insertBeforeId = destinationIndex < destinationCardIds.length ? destinationCardIds[destinationIndex] : null;

  const insertBefore = insertBeforeId ? filteredDestinationCards.find((c) => c.id === insertBeforeId) : null;
  const insertAfter = insertAfterId ? filteredDestinationCards.find((c) => c.id === insertAfterId) : null;

  const originalCardsInList = cards.filter((c) => c.listId === destinationListId);
  const originalIndex = originalCardsInList.findIndex((c) => c.id === sourceId);
  const originalBefore = originalIndex > 0 ? originalCardsInList[originalIndex - 1]?.id : null;
  const originalAfter =
    originalIndex < originalCardsInList.length - 1 ? originalCardsInList[originalIndex + 1]?.id : null;

  const isSameList = sourceCard?.listId === destinationListId;
  const isRedundantMove = isSameList && insertBeforeId === originalAfter && insertAfterId === originalBefore;

  if (isRedundantMove) return;

  let position;
  if (insertBefore && insertAfter) {
    position = Math.floor((insertBefore.position + insertAfter.position) / 2);
  } else if (insertAfter && !insertBefore) {
    position = insertAfter.position + INITIAL_POS;
  } else if (!insertAfter && insertBefore) {
    position = Math.floor(insertBefore.position / 2);
  } else {
    position = INITIAL_POS;
  }

  return { id: sourceId, listId: destinationListId, position, insertBeforeId, insertAfterId };
}
